import { useQuery } from "@tanstack/react-query";
import { CityOutput } from "~@/api/models";

const fetchAcademyCities = async (): Promise<CityOutput[]> => {
  try {
    const baseUrl = process.env.REACT_APP_J_ACADEMY_API_ENDPOINT as string;
    const url = `${baseUrl}cities`;

    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching academy cities:", error);
    return [];
  }
};

const useAcademyCitiesQuery = (enabled = true) => {
  const { data, isLoading, isPending, isError } = useQuery({
    queryKey: ["academy-cities"],
    queryFn: fetchAcademyCities,
    enabled,
  });

  return { data, isLoading, isPending, isError };
};

export default useAcademyCitiesQuery;
